
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1321Dialog extends Serenity.EntityDialog<Report_1321Row, any> {
        protected getFormKey() { return Report_1321Form.formKey; }
        protected getIdProperty() { return Report_1321Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1321Row.localTextPrefix; }
        protected getNameProperty() { return Report_1321Row.nameProperty; }
        protected getService() { return Report_1321Service.baseUrl; }
        protected getDeletePermission() { return Report_1321Row.deletePermission; }
        protected getInsertPermission() { return Report_1321Row.insertPermission; }
        protected getUpdatePermission() { return Report_1321Row.updatePermission; }

        protected form = new Report_1321Form(this.idPrefix);

    }
}